/**
 * Slate (PT betting-day) display helpers.
 * A slate is a YYYY-MM-DD string anchored to the PT betting day that rolls over at 3:00 AM PT.
 */
import { todayBettingDatePT, nextBettingDatePT } from "./timezone";

export type SlateRelative = "today" | "tomorrow" | "yesterday" | "other";

export function slateRelative(bettingDate: string | null | undefined, now = new Date()): SlateRelative {
  if (!bettingDate) return "other";
  const today = todayBettingDatePT(now);
  const tomorrow = nextBettingDatePT(now);
  if (bettingDate === today) return "today";
  if (bettingDate === tomorrow) return "tomorrow";
  // yesterday = today - 1 day (string compare safe for YYYY-MM-DD)
  const y = new Date(today + "T12:00:00Z");
  y.setUTCDate(y.getUTCDate() - 1);
  const yesterday = y.toISOString().slice(0, 10);
  if (bettingDate === yesterday) return "yesterday";
  return "other";
}

/** Short label e.g. "Today", "Tomorrow", "Mon, Nov 18". */
export function slateLabel(bettingDate: string | null | undefined, now = new Date()): string {
  if (!bettingDate) return "—";
  const rel = slateRelative(bettingDate, now);
  if (rel === "today") return "Today";
  if (rel === "tomorrow") return "Tomorrow";
  if (rel === "yesterday") return "Yesterday";
  return new Date(bettingDate + "T12:00:00Z").toLocaleDateString("en-US", {
    timeZone: "America/Los_Angeles",
    weekday: "short",
    month: "short",
    day: "numeric",
  });
}

/** "Today's", "Tomorrow's", "Yesterday's", or e.g. "Mon Nov 18". */
export function slatePossessive(bettingDate: string | null | undefined, now = new Date()): string {
  const rel = slateRelative(bettingDate, now);
  if (rel === "today") return "Today's";
  if (rel === "tomorrow") return "Tomorrow's";
  if (rel === "yesterday") return "Yesterday's";
  return slateLabel(bettingDate, now);
}

export const ROLLOVER_HINT = "Betting day rolls over at 3:00 AM PT.";
